
/**
 * @author Camilo
 * @since 11/02/2019
 */
export class Reporte{
    constructor(public VNOMBRECIERRE:string, public INICIO:Date, public FIN:Date, public NIDCIERRE:string){}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ReporteFacturacion/Reporte.model.ts